export const REGEX_WHITE_SPACE = /\s+/g; // REGEX: target whitespace
export const REGEX_NON_WORD_CHARS = /([^\w-]|_)+/g; // REGEX: target non-word chars including underscore
export const REGEX_MULTIPLE_DASH = /--+/g; // REGEX: target multiple dashes
export const REGEX_LEADING_DASH = /^-+/; // REGEX: target leading dash
export const REGEX_TRAILING_DASH = /-+$/; // REGEX: target trailing dash
export const REGEX_ALL_DIGITS = /^\d+$/; // REGEX: contains only digits 0-9
export const REGEX_DOLLAR_AMOUNT = /^\d+(\.\d{1,2})?$/; // REGEX: valid dollar amount with optional cents
export const REGEX_3_TO_4_DIGITS = /^[0-9]{3,4}$/; // REGEX: contains 3-4 digits
export const REGEX_AMPERSAND = /&/g; // REGEX: target ampersand
export const REGEX_NEWLINES = /[\r\n]+/g; // REGEX: target line breaks
export const REGEX_CC_EXPIRY = /^(0[1-9]|1[0-2])\/?([0-9]{2})$/; // REGEX: credit card expiration date in format MM/DD
export const REGEX_NON_DIGITS = /\D/g; // REGEX: target non-digits
export const REGEX_NUMBERS_ONLY = /^[0-9]*$/; // REGEX: must be numbers only
export const REGEX_PROJECT_NAME = /[^a-zA-Z0-9_.!@#$%^&*()\-=`~,<>./?;:'"[\]{}\\| \s]/; // REGEX: No special characters allowed other than specified
